import { useEffect, useRef, useState } from "react";

import { IUnitConfig } from "#/features/User/types";

// Check whether a unit row is on screen or not. Per se visible on the
//  week-table viewport.
export const useUnitRowIsOnScreen = (unit: IUnitConfig) => {
  const [isVisible, setIsVisible] = useState(false);
  const rowRef = useRef<HTMLDivElement>(null);
  const root = document.querySelector(".week-view-table-wrapper");

  useEffect(() => {
    const currentElement = rowRef.current;
    if (!currentElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry?.isIntersecting ?? false),
      {
        // Adjust these options based on your needs
        root, // viewport
        rootMargin: "200px", // start observing slightly before the element comes into view
        threshold: 0, // trigger as soon as the element is visible
      },
    );

    observer.observe(currentElement);

    return () => {
      if (currentElement) observer.unobserve(currentElement);
    };
  }, [unit.id, root]);

  return {
    rowRef,
    isVisible,
  };
};
